/**
 * Catalogue vocabularies — the enumerated columns `0009_catalog` introduces.
 *
 * Same three-part treatment as every other enum in this schema (ruled 2026-08-04):
 * `text` + `CHECK` in SQL, the constant here, and `constraints.test.ts` asserting the
 * two are set-equal — plus the writability round-trip c13 made mandatory, because two
 * copies agreeing says nothing about whether the values can be stored.
 */
/**
 * A product's lifecycle. §4: draft → published → archived → tombstoned.
 *
 * **Not a ladder, and not reversible in one direction.** `tombstoned` is terminal and is
 * what the resolver serves a tombstone response for — a GTIN that existed and no longer
 * describes a product still resolves, because invariant 1 says a printed barcode never
 * dead-ends. `archived` is the recoverable one.
 *
 * Only `published` writes a `resolver_entries` row, which is why a draft product's GTIN
 * 404s honestly: nothing was ever mirrored.
 */
export const PRODUCT_STATUSES = ["draft", "published", "archived", "tombstoned"];
/**
 * What a media row holds. §4: image, doc, artwork.
 *
 * `artwork` is the generated barcode output and carries render params plus a content
 * hash in `meta`, so a re-render can be proved bit-identical (§8).
 */
export const MEDIA_KINDS = ["image", "doc", "artwork"];
/**
 * A batch's own lifecycle. `0012` adds the `CHECK`; `0009` deliberately left it open.
 *
 * **It never encodes recall state, and that is the whole reason the vocabulary is this
 * short.** A `'recalled'` value would be a second representation of a fact `recalls`
 * owns — it would go stale the moment a recall is lifted, and putting it back would need
 * exactly the machinery `recalls.restore` already is. This schema's standing rule is one
 * representation per fact, so a batch's status answers *"is this lot still something the
 * brand is managing?"* and nothing else. Whether its units are recalled is a question for
 * `recalls`, joined on `lot`.
 *
 * The values are transcribed from what `apps/api/src/routes/batches.ts` already writes
 * — which is `'active'` and nothing else — plus the retirement half the column exists
 * for. Per c28's lesson the source wins over any count stated in prose: if that route
 * ever writes a third value, this constant is wrong and the route is right.
 */
export const BATCH_STATUSES = ["active", "archived"];
//# sourceMappingURL=catalog.js.map